import { render, staticRenderFns } from "./SearchbarFilterSuggestionArg.vue?vue&type=template&id=47d05442&scoped=true&"
import script from "./SearchbarFilterSuggestionArg.vue?vue&type=script&lang=ts&"
export * from "./SearchbarFilterSuggestionArg.vue?vue&type=script&lang=ts&"
import style0 from "./SearchbarFilterSuggestionArg.vue?vue&type=style&index=0&id=47d05442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d05442",
  null
  
)

export default component.exports